<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div class="rowTipStyle" style="text-align: center;">
        </div>
        <div style="padding: 10px;">

          <div width="100%;" style="padding: 10px;">
            <div style="text-align: center;font-size:20px;margin:20px;font-weight: bold;">设置查询条件</div>

           <div style="margin-top: 20px;">
             <div style="font-size: 18px;margin-left: 20px;">
               预计可导入<span style="color:red;">{{dataList.length}}条</span>数据，请按照下面的步骤设置好各项内容：
             </div>
           </div>
            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">1.<span style="color:red;">*</span>请输入查询名称:</div>
              <div style="margin-top: 10px;margin-left: 20px;">
                <el-input v-model="form_name" placeholder="输入查询名称,如xx工资条,xx分班表,xx成绩单等" style="width:50%"></el-input>
              </div>
            </div>



            <div width="100%" style="font-size:20px;margin-top: 20px;">
              <div style="font-size:18px;margin-bottom: 10px;font-weight: bold;">
                2.选择查询条件</div>

              <div  style="margin-top: 10px;margin-left: 20px;">
                <div style="font-size: 16px;"><span
                    style="margin-bottom: 10px;">*请从左框中查询条件列(如姓名,身份证等,最多两个)选到右侧框中:</span></div>
                <div style="font-size: 16px;margin-top: 5px;"><span
                    style="color:red;margin-bottom: 10px;">特别注意:必须选择每个人都有数据的列,否则部分人将无法查询</span></div>
                <div style="text-align: left;display: flex;margin-top: 10px;">
                  <el-transfer target-order="push" v-model="selectedSearchCondition" :data="transferList" :titles="['可选的列','已选的列']">
                  </el-transfer>
                </div>
              </div>

              <div v-if="selectedSearchCondition.length>0" style="font-size: 14px;margin-top: 20px;margin-left:20px;">
                <div>手机端输入查询条件效果预览:</div>
                <div style="border: 1px solid lightgray;width: 50%;padding:20px;">
                  <div style="margin: 5px;">
                  <div v-if="selectedSearchCondition.length==1">
                    <div style="margin-top:10px;font-weight: bold;">{{selectedSearchCondition[0]}}</div>
                    <div style="margin-top:10px;"><input style="width:80%;border:1px solid lightgray;height: 30px;" placeholder="这里是输入的位置" readonly/></div>
                  </div>
                  <div v-if="selectedSearchCondition.length==2">
                    <div>
                      <div style="margin-top:10px;font-weight: bold;">{{selectedSearchCondition[0]}}</div>
                      <div style="margin-top:10px;"><input style="width:80%;border:1px solid lightgray;height: 30px;" placeholder="这里是输入的位置" readonly/></div>
                    </div>

                    <div>
                      <div style="margin-top:10px;font-weight: bold;">{{selectedSearchCondition[1]}}</div>
                      <div style="margin-top:10px;"><input style="width:80%;border:1px solid lightgray;height: 30px;" placeholder="这里是输入的位置" readonly/></div>
                    </div>

                    <div style="color:red;font-size: 12px;margin: 5px;">注:查询条件先后顺序可通过调整选入到右侧框中的先后顺序进行调整</div>

                  </div>
                  <div v-if="selectedSearchCondition.length>2">
                    <div style="color:red;">最多是2个查询条件,请重新选择！</div>
                  </div>

                  </div>

                </div>

              </div>

            </div>

            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">
                3.补充说明:
              </div>
              <div style="margin-top: 10px;margin-left: 20px;">
                <el-input type="textarea" v-model="search_description" placeholder="输入查询说明,通知,注意事项等,会显示在查询界面首页,所有的人都一样."
                  style="width:50%"></el-input>
              </div>
            </div>

<!--            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">
                4.预计可导入<span style="color:red;">{{dataList.length}}条</span>数据。
              </div>
            </div> -->

            <div style="padding: 10px;padding-bottom: 50px;margin-top: 20px;margin-bottom: 200px;">
              <div class="actionBarStyle">
                <el-row>
                  <div class="searchStyle">
                    <el-button type="primary" size="medium" @click="nextStep" style="width: 400px;">设置完成，确认无误,点我立即导入!</el-button>
                  </div>
                </el-row>
              </div>
            </div>


          </div>

        </div>

      </el-col>
    </el-row>

    <el-dialog title="操作确认" :visible.sync="setConditionConfirmVisible" width="40%">
      <span>

        <div>
          查询人需要正确输入<span style="color:red;font-weight: bold;">{{selectedSearchCondition}}</span>才能查到结果，确定吗?
        </div>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setConditionConfirmVisible = false">取消</el-button>
        <el-button @click="nextStepAction()" type="primary">确定,立即导入</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedSearchCondition: [],
        finalConditions: [],

        selectedCondition: '',

        input_pages: '1',
        import_data: '',

        show_public: false,
        is_public: '0',
        search_description: '',
        selected_column_names: '',
        message: '',

        setConditionConfirmVisible: false,

        form_id: '',

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session

      console.log('最后一部导入',this.username)

      this.dataList = JSON.parse(this.$route.params.dataList)
      this.headList = JSON.parse(this.$route.params.headList)
      this.import_data = this.$route.params.import_data

      this.transferList = []
      for (var i = 0; i < this.headList.length; i++) {
        let item = {
          key: this.headList[i].label,
          label: this.headList[i].label,
          disabled: false
        }
        this.transferList.push(item)
      }

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      if (this.form_id) {
        this.form_name = this.$route.params.form_name
      }

      // console.log('this.transferList', this.transferList)
    },
    methods: {
      nextStep() {

        let that = this

        if (Utils.isEmpty(this.form_name)) {
          // this.$message.error('请输入查询名称')
          this.$alert('请输入查询名称')
          return
        }
        // console.log('this.transferList', this.transferList)
        // console.log('this.selectedSearchCondition', this.selectedSearchCondition)

        if (this.selectedSearchCondition.length === 0) {
          // this.$message.error('至少需要选择一个列用做领表凭证')
          this.message = '至少选一个查询条件,如姓名、工号、学号等(最多2个)'
          // this.dialogVisible = true
          // this.$message.error(this.message)
          this.$alert(this.message)
          return
        }

        if (this.selectedSearchCondition.length > 2) {
          this.message = '不要超过2个查询条件(最多2个),否则录入会很困难,请重新选择！'
          // this.$message.error(this.message)

          this.$alert(this.message)
          return
        }

        this.setConditionConfirmVisible = true

      },
      nextStepAction() {

        let that = this

        if (this.show_public) {
          that.is_public = '1'
        } else {
          that.is_public = '0'
        }


        var jsonConditionStr = JSON.stringify(that.selectedSearchCondition)

        var requestUrl = '/wansearch/web/_import_excel_form_data.jsp'
        // 开启loading

        let data = {
          username: that.username,
          form_name: that.form_name,
          head_list: JSON.stringify(that.headList),
          data_list: JSON.stringify(that.dataList),

          input_pages: that.input_pages,
          import_data: that.import_data,


          search_conditions: jsonConditionStr,
          public_condition: that.is_public,
          search_description: that.search_description,

          form_id: that.form_id
        }

        // console.log('head_list====', that.headList)

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在导入,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$message({
              duration: 5000,
              message: '导入成功！如需修改，请在Excel中修改好后重新导入即可！',
              type: 'success'
            })
            load.close()

            if (that.import_data === '1') {
              // 判断是否有固定列数据
              // var formId = response.data.form_id
              // that.$router.push({
              //   name: 'set_query_condition',
              //   params: {
              //     form_id: formId,
              //     form_name: that.form_name
              //   }
              // })
              // } else {
              that.$router.push({
                path: '/query_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.back()
      },
      hasFixColumn() {
        let that = this
        var hasFixed = false

        for (var i = 0; i < that.headList.size(); i++) {
          let column = that.headList[i]
          if (column.can_edit == '0') {
            hasFixed = true
            break
          }
        }

        return hasFixed
      },
      showPublicTips() {
        let that = this

        this.finalConditions = []

        var tstr = ''

        for (var i = 0; i < that.selectedSearchCondition.length; i++) {

          var str = ''
          if (i === 0) {
            // str = that.getTransferLabel(that.selectedSearchCondition[0])
            str = that.selectedSearchCondition[0]
            tstr = str
          } else {
            // str = that.getTransferLabel(that.selectedSearchCondition[i])
            str = that.selectedSearchCondition[i]
            tstr = tstr + '、' + str
          }

          // this.finalConditions.push(str)

        }

        if (tstr !== '') {
          tstr = '"' + tstr + '"'
        }

        // this.selected_column_names = tstr

        var tempstr = '公开' + tstr + '条件的值,便于领表人选入查询条件(不涉及隐私时使用)'

        return tempstr
      },
      getTransferLabel(field_name) {
        console.log(this.transferList, field_name)

        var label = ''
        for (var i = 0; i < this.transferList.length; i++) {
          let obj = this.transferList[i]
          if (obj.key == field_name) {
            label = obj.label
            break
          }
        }

        return label
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_import_final_step_ai.vue